module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iI2ZmY2UwMCIgZD0iTTAgMzIwaDY0MHYxNjAuMDAySDB6Ii8+CiAgPHBhdGggZD0iTTAgMGg2NDB2MTYwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2QwMCIgZD0iTTAgMTYwaDY0MHYxNjBIMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/de.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/de.svg
// module chunks = 0